import {
  INDRET_INICIALITZAR,
  INDRET_INTRODUCCIO_MOSTRAR_ERRORS,
  INDRET_INTRODUCCIO_DESCARTAR_CANVIS
} from "../../../actions/actionTypes";

const ESTAT_INICIAL = false;

const mostrarErrors = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INDRET_INICIALITZAR:
    case INDRET_INTRODUCCIO_DESCARTAR_CANVIS:
      return ESTAT_INICIAL;

    case INDRET_INTRODUCCIO_MOSTRAR_ERRORS:
      return true;

    default:
      return state;
  }
};

export default mostrarErrors;
